<template>
  <v-container fluid class="align-start align-content-start fill-height">
    <EmployeeListHeader
      @search="patchDynamicSearchFiled($event)"
      @activeTab="selectedTab = $event"
      @import="showImportDialog = true"
      @exportUsersList="exportUsersList($event)"
      @addEmployeeClick="addEmployeeClick()"
      @addEmployeeGroupClick="addEmployeeGroupClick()"
    />

    <EmployeeList
      v-if="selectedTab && selectedTab.tab !== 'groups'"
      :employees="
        selectedTab.tab === 'employee'
          ? businessPassengers
          : guestPassengers
        "
      :employeesLoading="selectedTab.tab === 'employee' ? businessPassengersLoading : guestPassengersLoading"
      :selectedTab="selectedTab.tab"
      :tableHeader="selectedTab.tab === 'employee' ? tableHeader : guestTableHeader"
      :totalPassengers="selectedTab.tab === 'employee' ? totalBusinessPassengers : totalGuestPassengers"
      @options="handleLoadByOptions"
      @resendEmailClick="resendEmailClick($event)"
      @editEmployeeClick="editEmployeeClick($event)"
      @deleteEmployeeClick="deleteEmployeeClick($event)"
    />

    <EmployeeListGroups
      v-else
      ref="employeeListGroups"
      :groups="businessPassengerGroups"
      :totalGroups="totalBusinessPassengerGroups"
      @options="handleLoadByOptions"
      @deleteEmployeeGroupClick="deleteEmployeeGroupClick($event)"
    />

    <dialog-wrapper
      ref="employeeDialog"
      :width="dialogWidth"
      @closeDialog="initCallPassengers(selectedTab.tab)"
    >
      <template v-slot:dialogContent>
        <create-employee-form
          v-if="selectedTab.tab === 'employee'"
          :employeeData="employee"
          :mode="mode"
          @closeDialog="closeDialog"
        />

        <create-guest-form
          v-if="selectedTab.tab === 'guest'"
          :guestData="employee"
          :mode="mode"
          @closeDialog="closeDialog"
        />
      </template>
    </dialog-wrapper>
    <v-dialog persistent width="680" :value="showImportDialog">
      <employee-import @cancel="showImportDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script>
import { BUSINESS_GUEST_HEADER, BUSINESS_PASSANGER_HEADER } from '@/constants/tables';

import EmployeeListHeader from '@/components/employee/v2/EmployeeListHeader.vue';
import EmployeeList from '@/components/employee/v2/EmployeeList.vue';
import EmployeeListGroups from '@/components/employee/v2/EmployeeListGroups.vue';

import EmployeeImport from '@/components/employee/EmployeeImport.vue';
import CreateEmployeeForm from '@/components/employee/v2/form/CreateEmployeeForm.vue';
import CreateGuestForm from '@/components/employee/v2/form/CreateGuestForm.vue';
import DialogWrapper from '@/components/elements/DialogWrapper.vue';

import { businessPassenger, exportPassengers } from '@/mixins/passenger.mixins';

export default {
  components: {
    EmployeeListHeader,
    DialogWrapper,
    CreateEmployeeForm,
    CreateGuestForm,
    EmployeeImport,
    EmployeeList,
    EmployeeListGroups,
  },
  mixins: [businessPassenger, exportPassengers],
  data() {
    return {
      employee: null,
      mode: 'add',
      dialogWidth: 600,
      showImportDialog: false,
      selectedTab: null,
    };
  },
  computed: {
    tableHeader() {
      return BUSINESS_PASSANGER_HEADER;
    },
    guestTableHeader() {
      return BUSINESS_GUEST_HEADER;
    },
  },
  watch: {
    selectedTab(val) {
      if (val) {
        this.initCallPassengers(val.tab);
      }
    },
  },
  methods: {
    closeDialog(submitted) {
      this.$refs.employeeDialog.close();

      if (submitted) {
        this.initCallPassengers(this.selectedTab.tab);
      }
    },
    patchDynamicSearchFiled(value) {
      if (this.selectedTab.tab === 'employee') {
        this.searchObject.dynamicSearch = value;
      } else if (this.selectedTab.tab === 'guest') {
        this.searchGuestObject.dynamicSearch = value;
      } else {
        this.searchPassengerGroupsObject.dynamicSearch = value;
      }
    },
    handleLoadByOptions(options) {
      const {
        page, itemsPerPage, sortBy, sortDesc,
      } = options;

      if (this.selectedTab.tab === 'employee') {
        const order = sortBy[0] || 'createdAt';
        this.searchObject = {
          ...this.searchObject,
          page: page - 1,
          maxPerPage: itemsPerPage,
          orderBy: sortDesc[0] ? `-${order}` : order,
        };
      } else if (this.selectedTab.tab === 'guest') {
        const order = sortBy[0] || 'createdAt';
        this.searchGuestObject = {
          ...this.searchGuestObject,
          page: page - 1,
          maxPerPage: itemsPerPage,
          orderBy: sortDesc[0] ? `-${order}` : order,
        };
      } else {
        const order = sortBy[0] || 'createdAt';
        this.searchPassengerGroupsObject = {
          ...this.searchPassengerGroupsObject,
          page: page - 1,
          maxPerPage: itemsPerPage,
          sort: sortDesc[0] ? `-${order}` : order,
        };
      }
    },
    async resendEmailClick(employee) {
      this.dialogWidth = 400;
      this.$refs.employeeDialog.openDialog({ type: 'resend-email', id: employee.id, corporationId: employee.corporationId });
    },
    async deleteEmployeeClick(employee) {
      this.dialogWidth = 400;
      this.$refs.employeeDialog.openDialog({
        type: this.selectedTab.tab === 'employee' ? 'delete-user' : 'delete-guest',
        id: employee.id,
      });
    },
    deleteEmployeeGroupClick(group) {
      this.dialogWidth = 400;
      this.$refs.employeeDialog.openDialog({ type: 'delete-group', id: group.id });
    },
    addEmployeeClick() {
      this.mode = 'add';
      this.employee = null;

      if (this.selectedTab.tab === 'guest') {
        this.employee = {
          role: 'guest',
        };
      }

      this.dialogWidth = 600;
      this.$refs.employeeDialog.openDialog();
    },
    addEmployeeGroupClick() {
      this.$refs.employeeListGroups.toggleGroupCreation();
    },
    async editEmployeeClick(employee) {
      this.employee = (
        await this.$store.dispatch('employee/findUsers', {
          ids: [employee.id],
          page: 0,
        })
      ).data[0] || null;

      this.mode = 'edit';
      this.dialogWidth = 600;

      this.$refs.employeeDialog.openDialog();
    },
  },
};
</script>
